<template>
  <div class="nav-wrapper">
    <div class="floating-nav" :class="{ hidden: navHidden }">
      <div class="nav-toggle" @click="navHidden = !navHidden">
        {{ navHidden ? '◀' : '▶' }}
      </div>
      <div class="floating-title">快速导航</div>
      <div class="search-container">
        <input type="text" v-model="searchQuery" placeholder="搜索模型..." class="search-input" />
        <button v-if="searchQuery" @click="clearSearch" class="clear-btn">×</button>
      </div>
      <div class="floating-links">
        <div v-for="model in displayModels" :key="model.id"
          :class="['floating-link', { active: currentModel === model.id }]" @click="scrollToModel(model.id, $event)">
          {{ model.name }}
        </div>
        <div v-if="displayModels.length === 0 && searchQuery" class="no-results">无匹配结果</div>
      </div>
      <div class="back-to-top-btn">
        <div class="floating-link" style="font-weight: bold;" @click="scrollToTop">回到顶部</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavMenu',
  props: {
    models: { type: Array, required: true },
    showBackToTop: { type: Boolean, default: false }
  },
  data() {
    return {
      navHidden: false,
      searchQuery: '',
      currentModel: '',
      lastScrollY: 0,
      hideTimer: null
    }
  },
  computed: {
    displayModels() {
      if (!this.searchQuery) return this.models;
      const q = this.searchQuery.toLowerCase();
      return this.models.filter(m => m.name.toLowerCase().includes(q) || m.id.toLowerCase().includes(q));
    }
  },
  watch: {
    models() {
      this.currentModel = '';
      this.searchQuery = '';
      this.forceAllTop();
    },
  },
  mounted() {
    window.addEventListener('scroll', this.updateCurrentModel);
    this.forceAllTop();
    this.updateCurrentModel();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateCurrentModel);
    if (this.hideTimer) clearTimeout(this.hideTimer);
  },
  methods: {
    forceAllTop() {
      setTimeout(() => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        window.scrollTo(0, 0);
        const c = document.querySelector('.main-content');
        if (c) c.scrollTop = 0;
      }, 20);
    },
    clearSearch() {
      this.searchQuery = '';
    },
    scrollToModel(id, e) {
      e.stopPropagation();
      const el = document.getElementById(id);
      if (!el) return;
      const container = document.querySelector('.main-content') || window;
      const offset = el.offsetTop - 100;
      container.scrollTo({ top: offset, behavior: 'smooth' });
      this.currentModel = id;
    },
    scrollToTop() {
      this.forceAllTop();
      this.currentModel = this.models[0]?.id || '';
    },
    updateCurrentModel() {
      const hasElements = this.models.some(m => document.getElementById(m.id));
      if (!hasElements) {
        this.currentModel = '';
        this.forceAllTop();
        return;
      }
      const scrollTop = document.querySelector('.main-content')?.scrollTop || window.scrollY;
      const pos = scrollTop + 150;
      let active = '';
      this.models.slice().reverse().forEach(m => {
        const el = document.getElementById(m.id);
        if (el && el.offsetTop <= pos) active = m.id;
      });
      this.currentModel = active || this.models[0]?.id || '';
    }
  }
}
</script>

<style scoped>
.nav-wrapper {
  position: relative;
  z-index: 100;
}

.floating-nav {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  padding: 10px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  backdrop-filter: blur(5px);
  border: 1px solid #e4e7ed;
  transition: all 0.3s ease;
  width: 150px;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
}

.floating-nav.hidden {
  transform: translateY(-50%) translateX(110%);
}

.nav-toggle {
  position: absolute;
  padding-left: 10px;
  left: -35px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #e4e7ed;
  border-right: none;
  border-radius: 8px 0 0 8px;
  width: 25px;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  transition: all 0.3s ease;
}

.nav-toggle:hover {
  background: #fff;
  color: #ffad32;
}

.floating-title {
  font-size: 14px;
  color: #333;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
  padding: 5px 0;
}

.search-container {
  position: relative;
  padding: 10px;
  border-bottom: 1px solid #e4e7ed;
  background: rgba(255, 255, 255, 0.95);
  margin-bottom: 10px;
}

.search-input {
  width: 100%;
  padding: 6px 24px 6px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 12px;
  outline: none;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.search-input:focus {
  border-color: #ffad32;
}

.clear-btn {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  border: none;
  background: none;
  color: #909399;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.clear-btn:hover {
  color: #666;
}

.floating-links {
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow-y: auto;
  max-height: 300px;
  margin-bottom: 10px;
  padding-right: 4px;
}

.floating-links::-webkit-scrollbar {
  width: 4px;
}

.floating-links::-webkit-scrollbar-track {
  background: transparent;
}

.floating-links::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}

.floating-link {
  color: #666;
  font-size: 13px;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.3s ease;
  text-align: center;
  cursor: pointer;
  user-select: none;
}

.floating-link:hover {
  color: #ffad32;
  background: #fff;
  transform: translateX(-2px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.floating-link.active {
  color: #fff;
  background: #ffad32;
  font-weight: bold;
}

.back-to-top-btn {
  border-top: 1px solid #e4e7ed;
  padding-top: 10px;
  margin-top: auto;
  background: rgba(255, 255, 255, 0.95);
  padding-bottom: 5px;
}

.no-results {
  color: #909399;
  font-size: 12px;
  text-align: center;
  padding: 20px 0;
  font-style: italic;
}
</style>